
<div class="records-list-wrap">
  <div class="db-panel_flex">
    <div class="db-dns-block-body" id="db-dns-block-body">
      <div class="record-item-header">
        <span class="record-item__name">{{ 'text_type' | dbText }}</span>
        <span class="record-item__name">{{ 'text_name' | dbText }}</span>
        <span class="record-item__name">{{ 'text_value' | dbText }}</span>
        <span class="record-item__name">TTL</span>
      </div>
      <div class="record-item" *ngFor="let record of zone.records; let x = index">
        <div class="record-ite__type {{record?.type}}">
          <span>{{record?.type}}</span>
        </div>
        <div class="record-ite__name {{record?.type}}">
          <span class="record-item__name-value"
                ngxClipboard [cbContent]="record?.name" (cbOnSuccess)="copiedNameServer(x)"
                dsTooltipSize="small" dsTooltipPosition="top"
                dsTooltipAlign="right"
                dsTooltipColor="black"
                [hostClass]="'cover-all'"
                [dsTooltip]="'<b>' + ((isCopied[x] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
                  <span class="record-item__with-tooltip"
                        [dsTooltip]="record?.name"
                        dsTooltipPosition="bottom"
                        [dsTooltipColor]="'black'">
                    <span>{{record?.name | middleEllipsis: 25}}</span></span>
            <i class="db-icon db-icon-ds-copy ml8"></i>
          </span>
        </div>
        <div class="record-ite__value {{record?.type}}">
          <span class="record-item__name-value"
                ngxClipboard [cbContent]="record?.value" (cbOnSuccess)="copiedNameServer(x)"
                dsTooltipSize="small" dsTooltipPosition="top"
                dsTooltipAlign="right"
                dsTooltipColor="black"
                [hostClass]="'cover-all'"
               [dsTooltip]="'<b>' + ((isCopied[x] ? 'text_copied' : 'text_copy') | dbText) +'</b>'"
               *ngIf="!isCopied[x + 10]">
            <span class="record-item__with-tooltip">
              <span [dsTooltip]="record?.value"
                    dsTooltipPosition="bottom"
                    [dsTooltipColor]="'black'">
                <span [ngClass]="{'db-pre-wrap': record?.type === 'MX'}" [innerHtml]="record?.type === 'MX' ? replaceString(record?.value) : (replaceString(record?.value) | middleEllipsis: 25)"></span>
              </span>
            </span>
            <i class="db-icon db-icon-ds-copy ml8"></i>
          </span>
        </div>
        <div class="record-ite__ttl {{record?.type}}"><span>{{record?.ttl | duration}}</span></div>
        <div class="no-back">
            <i (click)="addRecord.emit(record)" class="db-icon db-icon-ds-edit-website"></i>
        </div>
        <div class="record-ite__actions no-back">
          <div [dsTooltip]="dropdownList"
             class="dropdown"
             dsTooltipMode="click"
             dsTooltipPosition="top"
             dsTooltipAlign="right"
             dsTooltipSize="medium">
            <a class="more-icon-wrap">
              <i class="db-icon db-icon-more2"></i>
            </a>
          </div>
          <ng-template #dropdownList>
            <div class="ds-dropdown-list" (click)="RemoveRecord[0].action(record)">
              <div class="ds-dropdown-list__content">
                <div>
                  <ul>
                    <li>
                      <a class="ds-dropdown-list__item">
                        <span>{{RemoveRecord[0].label | dbText}}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
